import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Music, ArrowRight } from 'lucide-react';
import { cn } from '../lib/utils';

interface ChallengeNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLightMode: boolean;
}

export const ChallengeNoticeModal: React.FC<ChallengeNoticeModalProps> = ({
  isOpen,
  onClose,
  isLightMode
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className={cn(
              "relative w-full max-w-md p-6 sm:p-8 rounded-3xl shadow-2xl overflow-hidden",
              isLightMode ? "bg-white text-[#1a1a1a]" : "bg-[#1a1a1a] text-white border border-white/10"
            )}
          >
            {/* Background decorative elements */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#ff0080]/10 rounded-full blur-3xl pointer-events-none" />
            
            <button
              onClick={onClose}
              className={cn(
                "absolute top-4 right-4 p-2 rounded-full transition-colors z-10",
                isLightMode ? "hover:bg-black/5" : "hover:bg-white/10"
              )}
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="relative z-10">
              <div className="w-12 h-12 bg-[#ff0080] rounded-2xl flex items-center justify-center shadow-lg shadow-[#ff0080]/20 mb-6">
                <Music className="w-6 h-6 text-white" />
              </div>

              <h2 className="text-2xl font-black tracking-tight mb-3">
                Today's Challenge Update
              </h2>
              
              <div className={cn("text-sm space-y-3 mb-8 leading-relaxed", isLightMode ? "text-gray-600" : "text-gray-300")}>
                <p>
                  If you attempted today’s challenge earlier and ran into a dead end, there was an artist profile mix-up with Machine Gun Kelly that left him without his collaboration catalog.
                </p>
                <p>
                  We have updated the starting artist to <strong className={isLightMode ? "text-black" : "text-white"}>mgk</strong> with his complete tracklist. Today's route to <strong className={isLightMode ? "text-black" : "text-white"}>Ariana Grande</strong> is now fully playable and solvable in 2 steps.
                </p>
              </div>

              <button
                onClick={onClose}
                className="w-full py-4 rounded-full font-bold text-base flex items-center justify-center gap-2 bg-[#ff0080] text-white shadow-lg shadow-[#ff0080]/20 hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer"
              >
                <span>Got it, let's play</span>
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
